module.exports = __webpack_public_path__ + "img/leaguesp.9165adf0.svg";